module.exports = __webpack_public_path__ + "static/media/03.f2560362.mp3";